import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const ErrorPopup = ({ message, popupclose }) => {
  return (
    <>
      <div className="cong_bg">
        <div className="cong_pos">
          <button className="cross_tag" onClick={popupclose}>
            <img src="/assets/images/cross.svg" alt="" />
          </button>
          <img src="/assets/images/redinfo.svg" alt="" />
          <h2>Error !</h2>
          <p>{message}</p>
        </div>
      </div>
    </>
  );
};

export default ErrorPopup;
